import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircle as ReconciledIcon,
  Schedule as OutstandingIcon,
} from '@mui/icons-material';

// ---------------------------------------------------------------------------
// Shared Bank Reconciliation UI kit - mirrors the other ledger kits.
// A reconciliation is done when is_reconciled flips true; the difference
// (statement - book - cleared) must be explained before reconciling.
// ---------------------------------------------------------------------------

export const getErrorMessage = (error, fallback = 'Operation failed') => {
  const data = error?.response?.data;
  const message = data?.message || fallback;
  const details = data?.errors;
  if (!details) return message;
  const flat = Array.isArray(details)
    ? details.map((d) => (typeof d === 'string' ? d : JSON.stringify(d)))
    : Object.entries(details).map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(', ') : v}`);
  return flat.length ? `${message}: ${flat.join('; ')}` : message;
};

export const unwrap = (response) => response?.data?.data ?? response?.data ?? {};

export const unwrapList = (response) => {
  const payload = unwrap(response);
  return Array.isArray(payload) ? payload : payload.items ?? [];
};

export const fmtDate = (d) => {
  if (!d) return '-';
  const dt = new Date(d);
  return Number.isNaN(dt.getTime())
    ? String(d)
    : dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const ReconStatusChip = ({ reconciled }) => (
  reconciled
    ? <Chip icon={<ReconciledIcon fontSize="small" />} label="Reconciled" color="success" size="small" variant="outlined" />
    : <Chip icon={<OutstandingIcon fontSize="small" />} label="Outstanding" color="warning" size="small" variant="outlined" />
);

export const reconIdOf = (r) => r?.reconciliation_id ?? r?.id;
export const reconItemIdOf = (i) => i?.item_id ?? i?.id;
